export default function isValidDate(d: Date | string | unknown): boolean {
  if (typeof d === 'string') {
    const parsedDate = Date.parse(d)
    if (isNaN(parsedDate)) {
      return false
    }
    d = new Date(parsedDate)
  }
  return d instanceof Date && !isNaN(d.getTime())
}
